/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCategories,
    ControlcenterMelcoModelsCategoriesFromJSON,
    ControlcenterMelcoModelsCategoriesFromJSONTyped,
    ControlcenterMelcoModelsCategoriesToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsCategories
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsCategories {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCategories>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsCategories
     */
    list: Array<ControlcenterMelcoModelsCategories>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsCategories
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsCategories
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsCategoriesFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsCategories {
    return ControlcenterMelcoModelsGenericList1MelcoModelsCategoriesFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsCategories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsCategoriesFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsCategoriesToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsCategories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsCategoriesToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


